import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../css/TopBar.css";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedModel } from "../redux/modelSlice";
import profileIcon from "../assets/icons/profileIcon.png";
import settingIcon from "../assets/icons/settingIcon.png";
import helpIcon from "../assets/icons/helpIcon.png";
import logoutIcon from "../assets/icons/logoutIcon.png";
import { resetSidebarState } from "../redux/sidebarSlice"; // ✅ add this
import "../css/TopBar.css";

const SuperadminTopbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedModel = useSelector((state) => state.model.selectedModel);
  const selectedMenu = useSelector((state) => state.sidebar.selectedMenu);

  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("theme") === "dark";
  });

  const handleLogout = () => {
    localStorage.removeItem("token");
    dispatch(resetSidebarState());
    navigate("/");
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.remove("dark-mode");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  const toggleProfileMenu = () => setShowProfileMenu(!showProfileMenu);
  const closeMenu = () => setShowProfileMenu(false);
  const toggleDarkMode = () => setDarkMode(!darkMode);

  useEffect(() => {
    if (!selectedModel) {
      dispatch(setSelectedModel("LLaMA3.2"));
    }
  }, [dispatch, selectedModel]);

  return (
    <div>
      <nav className="topbar navbar navbar-expand-lg px-3 shadow-sm d-flex justify-content-between align-items-center bg-white">
        <div className="topbar-left">
          <h4 className="m-0 fw-bold">{selectedMenu}</h4>
        </div>
        <div className="d-flex align-items-center gap-3 ms-auto position-relative">
          <Link to="notifications" className="btn hi btn-link text-dark p-0">
            <i className="bi bi-bell fs-5"></i>
          </Link>

          {/* <button
            className="btn hi p-0 profile-circle border-0 rounded-circle d-flex justify-content-center align-items-center"
            onClick={toggleDarkMode}
            style={{
              backgroundColor: "#3e3e3e",
              width: "25px",
              height: "25px",
            }}
            title="Toggle Theme"
          >
            <i
              className={`bi ${darkMode ? "bi-moon" : "bi-sun"} text-white`}
              style={{ fontSize: "15px" }}
            ></i>
          </button> */}

          <button
            className="btn p-0 border-0 bg-transparent"
            onClick={handleLogout}
            title="Logout"
          >
            <i className="bi bi-box-arrow-right fs-5 text-dark"></i>
          </button>

          {/* <div className="position-relative">
            <button
              className="p-0 border-0 bg-transparent"
              onClick={toggleProfileMenu}
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                className="rounded-circle"
                alt="Avatar"
                style={{ width: "25px", height: "25px" }}
              />
            </button>

            {showProfileMenu && (
              <div
                className="dropdown-menu show profile-dropdown"
                onMouseLeave={closeMenu}
              >
                <Link
                  className="dropdown-item d-flex align-items-center border-bottom gap-2"
                  to="/profile"
                >
                  <img
                    src={profileIcon}
                    alt="Profile Img"
                    className="Profile-Svg"
                  />{" "}
                  <span className="Profile-text">Profile</span>
                </Link>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2"
                  to="/settings"
                >
                  <img
                    src={settingIcon}
                    alt="Profile Img"
                    className="Profile-Svg"
                  />{" "}
                  <span className="Profile-text">Settings</span>
                </Link>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2"
                  to="/getHelp"
                >
                  <img
                    src={helpIcon}
                    alt="Profile Img"
                    className="Profile-Svg"
                  />{" "}
                  <span className="Profile-text">Get Help</span>
                </Link>
                <button
                  className="dropdown-item d-flex align-items-center gap-2"
                  onClick={handleLogout}
                >
                  <img
                    src={logoutIcon}
                    alt="Profile Img"
                    className="Profile-Svg"
                  />{" "}
                  <span className="Profile-text">Logout</span>
                </button>
              </div>
            )}
          </div> */}
        </div>
      </nav>
    </div>
  );
};

export default SuperadminTopbar;
